export const BUSINESS = {
  name: "Asha Studios",
  nameMr: "आशा स्टूडियोज",
  rating: 4.9,
  address: "3rd Floor, Khandekar Sadan, Shri Samarth Hospital, Plot No.4, Green Fantasy, Tal-Haveli, Uruli Kanchan, Maharashtra 412202, India",
  plusCode: "F4PQ+88 Uruli Kanchan, Maharashtra, India",
  phone: "+91-9764750650",
  email: "info@ashastudios.in",
  hours: {
    weekdays: "11:00 AM - 6:00 PM",
    saturday: "11:00 AM - 6:00 PM",
    sunday: "(By Appt.)"
  },
  socials: {
    instagram: "https://www.instagram.com/asha_studios/",
    youtube: "https://www.youtube.com/@Asha_Studios",
    facebook: "https://www.facebook.com/people/Asha-Studios-and-RK-Audio-Lab/61590397475552/"
  },
  mapsUrl: "https://www.google.com/maps/place/Asha+Studios/@18.4858707,74.1383732,17z/data=!4m6!3m5!1s0x3bc2e152fe6952b5:0xd39f392a7f4d062d!8m2!3d18.4858707!4d74.1383732!16s%2Fg%2F11wsp0ly2r"
};

export const TRANSLATIONS = {
  en: {
    services: "Services",
    equipment: "Equipment",
    about: "About",
    testimonials: "Success Stories",
    bookNow: "Book Now",
    faq: "FAQ",
    contact: "Contact",
    bookSession: "Book Session",
    premiumExperience: "Premium Sound Experience",
    googleRating: "Google Rating",
    heroTitle_1: "Asha",
    heroTitle_2: "Studios",
    heroSubtitle: "A state-of-the-art studio for musicians who demand perfection. From world-class recording to cinematic sound design.",
    exploreServices: "Explore Services",
    scrollDown: "Scroll Down",
    ourServices: "Our Services",
    audioSolutions: "Professional Audio Solutions",
    ourHardware: "Our Hardware",
    sonicExcellence: "Sonic Excellence Through Premium Gear",
    aboutUs: "About Us",
    yourSound: "Your Sound, Our Passion",
    aboutText_1: "Asha Studios is a state-of-the-art recording facility located in Uruli Kanchan, Maharashtra. We provide professional audio recording, mixing, and mastering services for musicians, podcasters, and content creators.",
    aboutText_2: "Our studio is equipped with industry-standard equipment and acoustic treatment to ensure the highest quality sound capture. Whether you're recording your debut album, launching a podcast, or need professional voiceover work, we have the expertise and facilities to bring your vision to life.",
    yearsExperience: "Years Experience",
    projectsCompleted: "Projects Completed",
    hearFromClients: "Hear From Our Clients",
    successStoriesHeader: "Success Stories",
    readyToCreate: "Ready to Create Something Amazing?",
    bookingSubtitle: "Fill out the form and we'll get back to you within 24 hours to confirm your booking and discuss your project requirements.",
    workingHours: "Working Hours",
    location: "Location",
    fullName: "Full Name *",
    phoneNumber: "Phone Number *",
    emailAddress: "Email Address",
    preferredDate: "Preferred Date *",
    preferredTime: "Preferred Time *",
    serviceType: "Service Type *",
    duration: "Duration",
    budgetRange: "Budget Range",
    additionalMessage: "Additional Message",
    submitBooking: "Submit Booking Request",
    submitting: "Submitting...",
    gotQuestions: "Got Questions?",
    commonInquiries: "Common Inquiries",
    getInTouch: "Get in Touch",
    contactUs: "Contact Us",
    contactSubtitle: "Have questions about our services or want to discuss your project? Reach out to us and we'll get back to you as soon as possible.",
    callUs: "Call us",
    emailUs: "Email us",
    visitUs: "Visit us",
    followUs: "Follow Us",
    allRightsReserved: "All rights reserved.",
    designedDeveloped: "Designed & developed by",
    bookingSuccess: "Booking submitted successfully! We'll contact you soon.",
    bookingError: "Failed to submit booking. Please try again.",
    fillRequired: "Please fill in all required fields",
    selectDate: "Select date",
    selectTime: "Select time",
    selectService: "Select service",
    selectDuration: "Select duration",
    selectBudget: "Select budget",
    placeholderMessage: "Tell us about your project...",
    namePlaceholder: "Your full name",
    phonePlaceholder: "Phone number",
    emailPlaceholder: "your@email.com",
    analogSoul: "Analog Soul",
    followUsOn: "Follow Us",
    gallery: "Gallery",
    backToHome: "Back to Home",
    ourGallery: "Our Gallery",
    gallerySubtitle: "Take a visual tour of our state-of-the-art recording rooms, equipment racks, and live sessions.",
    allImages: "All Photos",
    categoryStudio: "Studio Setup",
    categoryEquipment: "Gear & Outboard",
    categorySessions: "Recording Sessions",
    releases: "Releases",
    featuredReleases: "Featured Releases",
    portfolioSubtitle: "Listen to tracks and projects recorded, mixed, and produced at Asha Studios.",
    openPlaylist: "Open Playlist on YouTube",
    openInMaps: "Open in Google Maps"
  },
  mr: {
    services: "सेवा",
    equipment: "साहित्य",
    about: "आमच्याबद्दल",
    testimonials: "यशस्वी कथा",
    bookNow: "आता बुक करा",
    faq: "नेहमीचे प्रश्न",
    contact: "संपर्क",
    bookSession: "सत्र बुक करा",
    premiumExperience: "प्रीमियम ध्वनी अनुभव",
    googleRating: "गुगल रेटिंग",
    heroTitle_1: "आशा",
    heroTitle_2: "स्टुडिओज",
    heroSubtitle: "परिपूर्णतेची मागणी करणाऱ्या संगीतकारांसाठी अत्याधुनिक स्टुडिओ. जागतिक दर्जाच्या रेकॉर्डिंगपासून सिनेमॅटिक ध्वनी डिझाइनपर्यंत.",
    exploreServices: "सेवा पहा",
    scrollDown: "खाली स्क्रोल करा",
    ourServices: "आमच्या सेवा",
    audioSolutions: "व्यावसायिक ऑडिओ सोल्यूशन्स",
    ourHardware: "आमची उपकरणे",
    sonicExcellence: "प्रीमियम गियरद्वारे ध्वनी उत्कृष्टता",
    aboutUs: "आमच्याबद्दल",
    yourSound: "तुमचा आवाज, आमची आवड",
    aboutText_1: "आशा स्टुडिओज ही उरुळी कांचन, महाराष्ट्र येथे असलेली एक अत्याधुनिक रेकॉर्डिंग सुविधा आहे. आम्ही संगीतकार, पॉडकॅस्टर आणि कन्टेंट क्रिएटर्ससाठी व्यावसायिक ऑडिओ रेकॉर्डिंग, मिक्सिंग आणि मास्टरिंग सेवा प्रदान करतो.",
    aboutText_2: "आमचा स्टुडिओ उच्च दर्जाचे ध्वनी कॅप्चर सुनिश्चित करण्यासाठी उद्योग-मानक उपकरणे आणि अकौस्टिक ट्रिटमेंटने सुसज्ज आहे. तुम्ही तुमचा पहिला अल्बम रेकॉर्ड करत असाल, पॉडकास्ट लाँच करत असाल किंवा व्यावसायिक व्हॉइसओव्हर कामाची गरज असेल, आमच्याकडे तुमची दृष्टी प्रत्यक्षात आणण्यासाठी कौशल्य आणि सुविधा आहेत.",
    yearsExperience: "वर्षे अनुभव",
    projectsCompleted: "प्रकल्प पूर्ण झाले",
    hearFromClients: "आमच्या क्लायंटकडून ऐका",
    successStoriesHeader: "यशस्वी कथा",
    readyToCreate: "काहीतरी आश्चर्यकारक तयार करण्यास तयार आहात?",
    bookingSubtitle: "फॉर्म भरा आणि आम्ही तुमचे बुकिंग कन्फर्म करण्यासाठी आणि तुमच्या प्रकल्पाच्या गरजांवर चर्चा करण्यासाठी २४ तासांच्या आत तुमच्याशी संपर्क साधू.",
    workingHours: "कामाची वेळ",
    location: "ठिकाण",
    fullName: "पूर्ण नाव *",
    phoneNumber: "फोन नंबर *",
    emailAddress: "ईमेल पत्ता",
    preferredDate: "प्राधान्य दिलेली तारीख *",
    preferredTime: "प्राधान्य दिलेली वेळ *",
    serviceType: "सेवेचा प्रकार *",
    duration: "कालावधी",
    budgetRange: "बजेट श्रेणी",
    additionalMessage: "अतिरिक्त संदेश",
    submitBooking: "बुकिंग विनंती सबमिट करा",
    submitting: "सबमिट होत आहे...",
    gotQuestions: "काही प्रश्न आहेत?",
    commonInquiries: "नेहमीचे प्रश्न",
    getInTouch: "संपर्कात रहा",
    contactUs: "आमच्याशी संपर्क साधा",
    contactSubtitle: "आमच्या सेवांबद्दल काही प्रश्न आहेत किंवा तुमच्या प्रकल्पावर चर्चा करायची आहे का? आमच्यापर्यंत पोहोचा आणि आम्ही शक्य तितक्या लवकर तुमच्याशी संपर्क साधू.",
    callUs: "आम्हाला कॉल करा",
    emailUs: "आम्हाला ईमेल करा",
    visitUs: "आम्हाला भेट द्या",
    followUs: "आमचे अनुसरण करा",
    allRightsReserved: "सर्व हक्क राखीव.",
    designedDeveloped: "डिझाइन आणि विकसित",
    bookingSuccess: "बुकिंग यशस्वीरित्या सबमिट झाले! आम्ही लवकरच तुमच्याशी संपर्क साधू.",
    bookingError: "बुकिंग सबमिट करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    fillRequired: "कृपया सर्व आवश्यक फील्ड भरा",
    selectDate: "तारीख निवडा",
    selectTime: "वेळ निवडा",
    selectService: "सेवा निवडा",
    selectDuration: "कालावधी निवडा",
    selectBudget: "बजेट निवडा",
    placeholderMessage: "तुमच्या प्रकल्पाबद्दल आम्हाला सांगा...",
    namePlaceholder: "तुमचे पूर्ण नाव",
    phonePlaceholder: "फोन नंबर",
    emailPlaceholder: "तुमचा ईमेल पत्ता",
    analogSoul: "ॲनालॉग सोल",
    followUsOn: "आमच्याशी कनेक्ट रहा",
    gallery: "गॅलरी",
    backToHome: "मुख्यपृष्ठ",
    ourGallery: "आमची गॅलरी",
    gallerySubtitle: "आमच्या अत्याधुनिक रेकॉर्डिंग रूम, उपकरणे आणि रेकॉर्डिंग सत्रांची एक झलक पहा.",
    allImages: "सर्व फोटो",
    categoryStudio: "स्टुडिओ सेटअप",
    categoryEquipment: "साहित्य व गियर",
    categorySessions: "रेकॉर्डिंग सेशन्स",
    releases: "गाणी",
    featuredReleases: "आमची निर्मिती",
    portfolioSubtitle: "आशा स्टुडिओजमध्ये रेकॉर्ड, मिक्स आणि तयार केलेली काही प्रसिद्ध गाणी आणि प्रोजेक्ट्स ऐका.",
    openPlaylist: "यूट्यूबवर प्लेलिस्ट पहा",
    openInMaps: "गुगल मॅप्सवर उघडा"
  }
};
